import $ from 'jquery'
import enquire from 'enquire.js'

export default {
	init() {
		// JavaScript to be fired on all pages
	},
	finalize() {
		// JavaScript to be fired on all pages, after page specific JS is fired
		$('body').addClass('js-loaded');

		/* Header */
		$('body').on('click', 'header.main button.hamburger', function() {
			$('body').toggleClass('menu-open');
		});

		$('body').on('click', 'header.main\\:after', function() {
			$('body').toggleClass('menu-open');
		})

		$('body')
			.on('click', '.menu-item-has-children > a', function(e) {
				if(e.target != this) return;
				$(this).siblings('.sub-menu').toggleClass('open').focus();
				return false;
			})
			.on('focusout', '.sub-menu', function() {
				$(this).toggleClass('open');
			})

		/* Hero Carousel */
		$('.herocarousel.carouselenabled').slick({
			slide: '.slide',
			rows: 0, //removes inline-block
			autoplay: true,
			autoplaySpeed: 5000,
			centerMode: true,
			dots: true,
			arrows: false,
		})

		/* Team Members Block */
		$('body').on('click', '.team_member .team_photo', function () {
			$(this).parent().siblings('.team_member').removeClass('open');
			$(this).parent().siblings('.team_member').children('.team_bio_wrapper').scrollTop(0);
			$(this).parent().toggleClass('open');
		})
		$('body').on('click', '.team_member .hamburger', function () {
			$(this).parent().toggleClass('open');
		})

		/* Intersection Animations */
		if(window.IntersectionObserver) {
			const sbsBlocks = document.querySelectorAll('.sbs_block');
			const sbsOptions = {
				root: null,
				rootMargin: '0px 0px -200px 0px',
			};
			const sbsObserver = new IntersectionObserver(function(entries, observer) {
				entries.forEach((entry) => {
					if (!entry.isIntersecting) {
						return;
					} else {
						// console.log(entry);
						entry.target.classList.add('in_viewport');
						observer.unobserve(entry.target);
					}
				});
			}, sbsOptions);

			sbsBlocks.forEach(sbsBlock => sbsObserver.observe(sbsBlock));

			enquire.register('screen and (min-width: 1024px)', {
				match : function() {
					//nada
				},
				unmatch : function() {
					//nada
				},
			});
		}
	},
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js